import { h } from "@stencil/core";
import localI18n from "../../../util/i18n";
import { interval, Subject, takeUntil } from "rxjs";
export class SessionExpirationInactivityWarnPopUp {
    constructor() {
        this.open = false;
        this.remainingIdleDisplayTime = undefined;
        this.remainingIdleDisplayTimeScreenreader = undefined;
        this.firstFocusableElement = undefined;
        this.lastFocusableElement = undefined;
    }
    el;
    remainingIdleTime;
    finished = new Subject();
    async eventListener(event) {
        if (event.detail.msUntilIdleTimeout > 0) {
            this.finished.next(true);
            // Can only display whole seconds
            this.remainingIdleTime = Math.floor(event.detail.msUntilIdleTimeout / 1000) * 1000;
            this.formatSessionIdleTime(this.remainingIdleTime);
            this.startTicker();
            this.open = true;
            this.firstFocusableElement = this.el.shadowRoot.getElementById('session-expiration-idle-warn-popup-close');
            this.lastFocusableElement = this.el.shadowRoot.getElementById('session-expiration-idle-warn-popup-continue-btn');
            await new Promise((resolve) => setTimeout(resolve, 1));
            this.lastFocusableElement.focus();
        }
    }
    handleKeyDown(ev) {
        const tabWasPressed = ev.key === 'Tab';
        const escapeWasPressed = ev.key === 'Escape';
        if (escapeWasPressed) {
            this.handleCloseClick();
        }
        if (!tabWasPressed) {
            return;
        }
        const tabbingForwards = !ev.shiftKey;
        if (tabbingForwards && this.el.shadowRoot.activeElement === this.lastFocusableElement) {
            this.firstFocusableElement.focus();
            ev.preventDefault();
        }
        if (!tabbingForwards && this.el.shadowRoot.activeElement === this.firstFocusableElement) {
            this.lastFocusableElement.focus({ preventScroll: false });
            ev.preventDefault();
        }
    }
    formatSessionIdleTime(durationInMillis) {
        const durationInSec = durationInMillis / 1000;
        const mins = Math.floor(durationInSec / 60);
        const secs = durationInSec - mins * 60;
        this.remainingIdleDisplayTime = `${this.padTime(mins)}:${this.padTime(secs)}`;
        this.remainingIdleDisplayTimeScreenreader = `${mins}${localI18n.t('INACTIVITY_SESSION_IDLE_TIME_1')}${secs}${localI18n.t('INACTIVITY_SESSION_IDLE_TIME_2')}`;
    }
    padTime(time) {
        return String(time).padStart(2, '0');
    }
    startTicker() {
        interval(1000)
            .pipe(takeUntil(this.finished))
            .subscribe((_) => {
            if (this.remainingIdleTime <= 0) {
                this.finished.next(true);
            }
            else {
                this.remainingIdleTime = this.remainingIdleTime - 1000;
                this.formatSessionIdleTime(this.remainingIdleTime);
            }
        });
    }
    handleCloseClick() {
        this.open = false;
        this.finished.next(true);
    }
    render() {
        return (h("div", { key: 'e2d8f5bcf6beae73e4dac6c9c2218d4b1bc6dbbe', class: `modal overlay ${this.open ? 'is-visible' : ''}`, id: "popupIdle", tabindex: "-1", role: "dialog", "aria-label": localI18n.t('INACTIVITY_1'), "aria-hidden": "false" }, h("div", { key: '34f08d576bce385f714b379f0eb685442011e421', class: "modal-dialog modal-dialog-centered ba-prompt" }, h("div", { key: '8ff223136bf7c8ccd342367c84808be6bee7d107', class: "modal-content" }, h("div", { key: '1e34341a54a187e6134a066c09162f24f6c41c31', class: "modal-header" }, h("button", { key: '5e7c3d506b6653cb93bee606ba9e4e9281fa327e', id: "session-expiration-idle-warn-popup-close", type: "button", class: "ba-modal-close", "data-bs-dismiss": "modal", "aria-label": localI18n.t('INACTIVITY_2'), title: localI18n.t('INACTIVITY_2'), onClick: () => {
                this.handleCloseClick();
            } }), h("h1", { key: '6ab4cfb80273c041c2497b5d11139f6234a08154', class: "modal-title" }, localI18n.t('MIN_INACTIVITY_HEADLINE'))), h("div", { key: '78fc54f8faea97513ee3fc8fedeba2b7144e62e4', class: "modal-body" }, h("p", { key: '3fcac672d747973e81ef483018b3331e76a5f5b8' }, localI18n.t('INACTIVITY_3'), h("span", { key: 'e8d0f0282285fd029355f962606281b184610e5a', class: "inactivity-countdown", "aria-hidden": "true" }, this.remainingIdleDisplayTime), ' ', h("span", { key: '17f06b9f45bdc52eaee027ffa186defa85ee74ab', class: "sr-only inactivity-countdown" }, this.remainingIdleDisplayTimeScreenreader), localI18n.t('INACTIVITY_4'))), h("div", { key: 'eb3a7369e150333c124e1fb9c755081261a6eb0b', class: "modal-footer" }, h("button", { key: 'eb905a79866e8b7e40aec5b06b66323ac178a085', id: "session-expiration-idle-warn-popup-continue-btn", onClick: () => {
                this.handleCloseClick();
            }, class: "ba-btn ba-btn-primary", type: "button" }, localI18n.t('MIN_INACTIVITY_BUTTON')))))));
    }
    static get is() { return "session-expiration-inactivity-warn-popup"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["session-expiration-inactivity-warn-popup.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["session-expiration-inactivity-warn-popup.css"]
        };
    }
    static get states() {
        return {
            "open": {},
            "remainingIdleDisplayTime": {},
            "remainingIdleDisplayTimeScreenreader": {},
            "firstFocusableElement": {},
            "lastFocusableElement": {}
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "oiamIdleSessionExpirationWarnEvent",
                "method": "eventListener",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "handleKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
